import React from 'react';

import clsx from 'clsx';

export const TileFooter = ({ children, classModifier = null }) => (
  <div className={clsx('tile__footer', classModifier && classModifier)}>{children}</div>
);
